export enum FormStepButtonId {
  user_requests = 'user-requests-button',
  next = 'next-button',
  previous = 'previous-buton',
  approve_and_download = 'approve-and-download-button',
  sign = 'sign-button',
  pay = 'pay-button',
  download_file = 'download-file-button',
  home = 'hone-button',
}
